export default __webpack_public_path__ + "volume_off-1200-34324f68e821ce1e946a4131c8b9ec90.webp";